module.exports = __webpack_public_path__ + "img/conference3.f1c4a968.png";